// extracted by mini-css-extract-plugin
module.exports = {"container":"_1uG4KQ9F5-cStN-wrLseXQ"};